export enum AUDIO_ENHANCEMENT_ACTIONS {
    SET_AUDIO_ENHANCEMENT_TOGGLE = 'SET_AUDIO_ENHANCEMENT_TOGGLE',
    SET_AUDIO_ENHANCEMENT_LOADING = 'SET_AUDIO_ENHANCEMENT_LOADING',
}

export enum AUDIO_ENHANCEMENT_TOGGLE_STATUS {
    ON = 'ON',
    OFF = 'OFF',
}

export const AUDIO_ENHANCEMENT_ERRORS = {
    ENHANCEMENT_FAILED: 'Sorry, we could not enhance your audio.',
    LOAD_ORIGINAL_ASSET_FAILED: 'Sorry, the original asset could not be loaded.',
};
